import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import get from "lodash/get";
import {
  Container,
  InputContainer,
  Input,
  withStyles,
  withDrawer,
  Drawer2,
  // RadioButtons,
} from "components/common";
import formatCurrency from "utils/formatCurrency";
import { PAYMENT_AUTOPAY_INFO, CARD_STATUS } from "utils/constants";
import { LOCKED_STATUS_QUERY } from "utils";
import PaymentDrawer from "../PaymentDrawer";
import commafy from "../../../../utils/commafy";

const PaymentForm = ({
  user,
  mini,
  parentAmount,
  // radioCallback,
  onDrawerClose,
  hideAutopayDescription = false,
}) => {
  const [paymentTypes, setPaymentTypes] = useState([
    // {
    //   type: "Remaining statement balance",
    //   varName: "payment_due_balance",
    //   // eslint-disable-next-line
    //   selected: !mini && (user.autopay_frequency == "monthly"),
    //   // eslint-disable-next-line
    //   disabled: user.autopay_frequency != "monthly",
    //   id: 1
    // },
    {
      type: "Current balance",
      varName: "payment_due_balance",
      // eslint-disable-next-line
      selected: !mini && user.autopay_frequency != "monthly",
      id: 2,
    },
  ]);
  const [amountOptions, setAmountOptions] = useState([
    { amt: 1, selected: true },
    // { amt: 0.75, selected: false },
    // { amt: 0.5, selected: false },
    // { amt: 0.25, selected: false }
  ]);

  const [indicateActionRequired, setIndicateActionRequired] = useState(
    user.card?.status === CARD_STATUS.LOCKED && -user.payment_due_balance > 0,
  );

  const getAmt = (newPaymentTypes = paymentTypes) => {
    const selected = newPaymentTypes.find(
      (paymentType) => paymentType.selected,
    );
    let amt = selected ? get(user, selected.varName) : 0;
    if (selected.varName === "payment_due_balance") {
      amt = -amt;
    }

    return amt > 0 ? amt.toFixed(2) : 0;
  };

  const [amount, setAmount] = useState(getAmt());

  if (mini && parentAmount != amount) {
    setAmount(parentAmount);
    setPaymentTypes(paymentTypes.map((x) => ({ ...x, selected: false })));
  }

  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = () => {
    if (onDrawerClose) {
      onDrawerClose();
    }
    setDrawerOpen(false);
  };

  useEffect(() => {
    setAmount(getAmt());
    setIndicateActionRequired(
      user.card?.status === CARD_STATUS.LOCKED && -user.payment_due_balance > 0,
    );
  }, [user.payment_due_balance]);

  const getPendingTotal = () => {
    return user.pending_activity_summary?.volume || 0;
  };

  const [pendingActivityVolume, setPendingActivityVolume] = useState(
    getPendingTotal(),
  );

  useEffect(() => {
    setPendingActivityVolume(getPendingTotal());
  }, [user.pending_activity_summary]);

  return (
    <div className="w-full h-full">
      <Container
        paddingVertical={mini ? 0 : 20}
        className="w-full flex-1 h-full"
      >
        {mini || (
          <div className="text-lg font-bold mb-2">
            Make a Payment
            {indicateActionRequired && (
              <span className="text-critical ml-2">(Action Required)</span>
            )}
          </div>
        )}
        <div className="flex flex-col justify-between md:flex-row">
          <div className="md:mr-6 mb-2 flex flex-col items-start w-full">
            {/* <RadioButtons
              elements={paymentTypes}
              component={({ element }) => (
                <div className={`${element.disabled ? "text-gray-400" : ""}`}>
                  {element.type}
                </div>
              )}
              didSelect={data => {
                if (data.disabled) return;

                const newPaymentTypes = paymentTypes.map(paymentType => ({
                  ...paymentType,
                  selected: paymentType.type === data.type
                }));
                setPaymentTypes(newPaymentTypes);

                const totalAmount = getAmt(newPaymentTypes);
                const multiplier = amountOptions.find(
                  option => option.selected
                );
                const newAmount = multiplier
                  ? totalAmount * multiplier.amt
                  : totalAmount;
                setAmount(newAmount.toFixed(2));

                if (mini) radioCallback(newAmount);
              }}
              overrideIndex
            /> */}
            <div className="text-lg">
              Current Balance:{" "}
              <span
                className={`${
                  indicateActionRequired
                    ? "text-critical"
                    : "text-green-primary"
                }`}
              >
                {formatCurrency((-user.payment_due_balance || 0).toFixed(2))}
              </span>
            </div>
            <div className="text-lg">
              Pending Transactions:{" "}
              <span
                className={`${
                  indicateActionRequired
                    ? "text-critical"
                    : "text-green-primary"
                }`}
              >
                {formatCurrency(pendingActivityVolume.toFixed(2))}
              </span>
            </div>
          </div>

          {mini || (
            <div className="flex-end w-full">
              <div className="flex flex-col mb-2">
                <div className="flex">
                  <InputContainer className="flex-1 border-r-0 rounded-r-none py-4">
                    <div className="text-gray-500 mr-1">$</div>
                    <Input
                      type="text"
                      name="payment"
                      className="outline-none"
                      value={amount}
                      onFocus={() =>
                        setAmountOptions(
                          amountOptions.map((item) => ({
                            ...item,
                            selected: false,
                          })),
                        )
                      }
                      onChange={(e) => {
                        e.preventDefault();
                        setAmount(commafy(e.target.value));
                      }}
                    />
                  </InputContainer>
                  <button
                    type="button"
                    className="btn text-xl font-title rounded-l-none py-0"
                    onClick={(e) => setDrawerOpen(true)}
                  >
                    Pay
                  </button>
                </div>
                {user.delinquent && (<div className="self-end">
                  <span className="text-sm">Pay now to </span>
                  <span className="text-sm font-bold">protect your credit</span>
                </div>)}
              </div>
              {/* <div className="flex flex-1 -mx-1">
              {amountOptions.map(({ amt, selected }) => (
                <button
                  key={amt}
                  type="button"
                  className={classnames(
                    "border outline-none cursor-pointer mx-1 px-1 flex-1",
                    {
                      "border-green-primary text-green-primary": selected
                    }
                  )}
                  style={{ outline: 0 }}
                  onClick={() => {
                    const amtOptions = amountOptions.map(item => ({
                      ...item,
                      selected: item.amt === amt
                    }));
                    setAmountOptions(amtOptions);
                    const multiplier = amtOptions.find(
                      option => option.selected
                    ).amt;
                    const totalAmount = getAmt();
                    const newAmount = (totalAmount * multiplier).toFixed(2);
                    setAmount(newAmount || 0);
                  }}
                >
                  {`${amt * 100}%`}
                </button>
              ))}
            </div> */}
            </div>
          )}
        </div>
        {!hideAutopayDescription && (
          <div className="text-sm hidden md:block">{PAYMENT_AUTOPAY_INFO}</div>
        )}
      </Container>
      <Drawer2 isOpen={drawerOpen} close={closeDrawer}>
        <PaymentDrawer
          user={user}
          closeDrawer={closeDrawer}
          queries={[LOCKED_STATUS_QUERY]}
          amount={amount}
        />
      </Drawer2>
    </div>
  );
};

export default compose(
  connect((state) => ({
    nextPayment: state.user.nextPayment,
    // remainingStatementBalance: state.user.remainingStatementBalance,
    // amountDue: state.user.amountDue,
  })),
  withStyles,
  withDrawer,
)(PaymentForm);
